(function () {
  'use strict';

  function initPackSlider(container) {
    if (!container || container.dataset.packSliderInitialized === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    container.dataset.packSliderInitialized = 'true';

    new window.Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      speed: 6000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      freeMode: true,
      freeModeMomentum: false,
      grabCursor: true,
      a11y: {
        enabled: true,
      },
    });
  }

  function setupSection(section) {
    if (!section || section.dataset.packSectionInitialized === 'true') return;
    section.dataset.packSectionInitialized = 'true';

    var container = section.querySelector('.mySwiperWibrnt');
    if (!container) return;

    var url = section.dataset.swiperUrl;
    if (window.SwiperLazy) {
      window.SwiperLazy.observe(section, url, function () { initPackSlider(container); });
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('.wibrnt-pack-main');
    sections.forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = (e.target.classList && e.target.classList.contains('wibrnt-pack-main'))
        ? e.target
        : e.target.querySelector('.wibrnt-pack-main');
      if (section) setupSection(section);
    });
  }
})();
